import { AggregatedAnswer } from "@/features/survey-results/survey-results-types";
import { Question } from "../survey-types";
import PieChart from "./charts/PieChart";
import SimpleBarChart from "./charts/SimpleBarChart";
import QuestionTypeIcon from "../QuestionTypeIcon";
import OpinionScaleChart from "./charts/OpinionScaleChart";
import { TextSummaryChart } from "./charts/TextSummaryChart";
import HistogramChart from "./charts/HistogramChart";

interface AggregatedAnswerProps {
  question: Question;
  aggregatedAnswer: AggregatedAnswer;
}

const AggregatedAnswerComponent: React.FC<AggregatedAnswerProps> = ({
  question,
  aggregatedAnswer,
}) => {
  return (
    <div className="bg-slate-800 p-4 h-full">
      <h4>
        <QuestionTypeIcon type={question.type} /> &nbsp; {question.text}
        {!question.text && (
          <span className="text-slate-400">Empty question</span>
        )}
      </h4>
      {renderQuestionAnswer(question, aggregatedAnswer)}
    </div>
  );
};

function renderQuestionAnswer(
  question: Question,
  aggregatedAnswer: AggregatedAnswer
) {
  if (
    (question.type == "multiple-choice" && !question.multipleSelection) ||
    question.type == "yes-no"
  ) {
    return (
      // We need to specify a predefined size for the chart to render
      <div className="mt-4 mx-auto h-[300px] w-full">
        <PieChart histogram={aggregatedAnswer.histogram} />
      </div>
    );
  } else if (question.type == "multiple-choice" && question.multipleSelection) {
    return (
      <div className="mt-4">
        <SimpleBarChart histogram={aggregatedAnswer.histogram} />
      </div>
    );
  } else if (question.type == "opinion-scale") {
    return (
      // We need to specify a predefined size for the chart to render
      <div className="mt-4 mx-auto h-[300px] w-full">
        <OpinionScaleChart
          histogram={aggregatedAnswer.histogram}
          range={{ min: question.min || 1, max: question.max || 5 }}
        />
      </div>
    );
  } else if (question.type == "text") {
    return (
      // We need to specify a predefined size for the chart to render
      <div className="mt-4 mx-auto h-[300px] w-full">
        <TextSummaryChart textSummary={aggregatedAnswer.textSummary || ""} />
      </div>
    );
  } else if (question.type == "number") {
    return (
      // We need to specify a predefined size for the chart to render
      <div className="mt-4 mx-auto h-[300px] w-full">
        <HistogramChart histogram={aggregatedAnswer.histogram} />
      </div>
    );
  }
  return (
    <div className="text-red-800">
      Not implemented yet! (type: <b>{question.type} </b>)
    </div>
  );
}

export default AggregatedAnswerComponent;
